import React from "react";
import { Button, Result } from "antd";

const TenantNotFoundPageComponent = ({ tenantName = "" }) => {
  const handleRefresh = () => {
    window.location.reload();
  };

  const normalizedTenantName =
    typeof tenantName === "string" ? tenantName.trim() : "";
  const titleText = normalizedTenantName
    ? `Tenant "${normalizedTenantName}" Not Found`
    : "Tenant Not Found";
  const subtitleText = normalizedTenantName
    ? `No tenant exists for "${normalizedTenantName}". Please check the tenant name and try again.`
    : "The tenant in this URL does not exist. Please check the tenant name and try again.";

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Result
        status="404"
        title={titleText}
        subTitle={subtitleText}
        extra={
          <Button type="primary" onClick={handleRefresh}>
            Try Again
          </Button>
        }
      />
    </div>
  );
};

export default TenantNotFoundPageComponent;
